module.exports = __webpack_public_path__ + "img/send-white.963b5ee4.svg";